export const CtpsIconComponent = ({
  size = 32,
  fillColor = '#FFFFFF00',
  strokeColor = '#454545',
  strokeWidth = 2,
  style
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect width="32" height="32" rx="16" fill={fillColor} />
    <g transform="translate(7, 6) scale(0.75)">
    <path stroke={strokeColor} stroke-linecap="round" stroke-linejoin="round" stroke-width={strokeWidth} d="M3 17a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm3 3a1 1 0 0 0 1 1h3.756a1 1 0 0 0 .958-.713l1.2-3c.09-.303.133-.63-.056-.884C12.67 16.149 12.316 16 12 16h-2v-2.467a1.1 1.1 0 0 0-2.015-.61L6 16v4zm8-17v4a1 1 0 0 0 1 1h4"/>
    <path stroke={strokeColor} stroke-linecap="round" stroke-linejoin="round" stroke-width={strokeWidth} d="M5 12.1V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2h-2.3"/>
    </g>
    </svg>
);